import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    NewPatient: {
        id: 'Components.NewExistingRadio.NewPatient',
        defaultMessage: 'New patient',
    },
    NewPatientSmall: {
        id: 'Components.NewExistingRadio.NewPatientSmall',
        defaultMessage: 'No',
    },
    ExistingPatient: {
        id: 'Components.NewExistingRadio.ExistingPatient',
        defaultMessage: 'Existing patient',
    },
    ExistingPatientSmall: {
        id: 'Components.NewExistingRadio.ExistingPatientSmall',
        defaultMessage: 'Yes',
    },
});
